<template>
  <a
    v-if="asset.filename"
    download
    :href="asset.filename"
    target="_blank"
    :aria-label="filename ? t('global.downloadX', { filename }) : t('global.downloadFile')"
    @mouseenter="onIconMouseOver"
    @mouseleave="onIconMouseOut">
    <slot></slot>
  </a>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useIconAnimation } from '@seb-platform/shared/composables';

const { onIconMouseOver, onIconMouseOut } = useIconAnimation();

defineProps<{
  /**
   * Mimicks type `AssetStoryblok`
   */
  asset: { filename?: string | null };
  filename?: string;
}>();

const { t } = useI18n();
</script>
